<template>
  <div class="tab-wrapper col-xs-12 p-0">
    <div class="tab-section">
      <div class="d-flex tabs col-gap-30">
        <div
          v-for="tab in availableTabsList"
          :key="tab.key"
          class="tab-item cursor-pointer"
          :class="{ active: activeTab === tab.displayFilter }"
          @click="setSelectedTab(tab.displayFilter)"
        >
          {{ translateName(tab.displayFilter) }}
        </div>
      </div>
    </div>

    <div class="list-user-action-section">
      <div class="d-flex align-items-center pl-16 pr-16">
        <div class="tab-count font-14" style="flex: 10%;">
          {{ searchResultCount }}
          <span v-if="searchResultCount === 1">{{ $t('itemText') }}</span>
          <span v-else>{{ $t('items') }}</span>
        </div>
        <div class="tab-search" style="flex: 80%;">
          <input :placeholder="$t('searchProduct')" class="search-input-field" type="text" v-model="searchKeyword" @keydown.enter="search" />
          <img class="search-icon" src="/static/images/icons/new_emergo_search_icon.svg" alt="search-icon" />
        </div>
        <div
          @click="showAppliedFilters"
          class="filter-list cursor-pointer d-flex justify-content-center col-gap-10 emergo-neutrals-gray font-14"
          style="flex: 10%;"
        >
          <img class="filter-icon" src="/static/images/icons/new_filter_icon.svg" alt="filter-icon" />
          <span>{{$t('filter')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchResultCount: {
      type: Number
    },
    filteredData: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      required: true
    },
    activeTab: String,
    tabsList: {
      type: Array,
      required: true
    },
    roleInfo: Object,
    roleId: Number
  },
  data() {
    return {
      availableTabsList: [],
    };
  },
  watch: {
    tabsList: {
      handler() {
        if (this.tabsList) {
          this.availableTabsList = this.tabsList.filter(
            (tab) => tab.displayFilter !== 'In progress'
          );
          if (this.roleId === this.roleInfo['RA Admin']) {
            this.availableTabsList = this.tabsList.filter(
              (tab) => tab.displayFilter !== 'Invalid Records' && tab.displayFilter !== 'In progress'
            );
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    searchKeyword: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },

  methods: {
    showAppliedFilters() {
      this.$emit('setShowFilter');
    },
    search() {
      this.$emit('search', this.searchKeyword);
    },
    translateName(name) {
      if (this.$i18n.locale === 'Portuguese') {
        // eslint-disable-next-line no-nested-ternary
        switch (name) {
          case 'View All':
            name = 'View_all';
            break;
          case 'Action Needed':
            name = 'action_needed';
            break;
          case 'Invalid Records':
            name = 'Invalid_records';
            break;
          default:
            break;
        }
        const data = {
          View_all: 'Ver Todos',
          Expired: 'Expirados',
          action_needed: 'Ação Necessária',
          Pending: 'Pendentes',
          Archive: 'Arquivados',
          Draft: 'Rascunho',
          Invalid_records: 'Certificados inválidos',
          Active: 'Ativo'
        };
        return data[name];
      }
      return name === 'Invalid Records' ? 'Invalid Certificates' : name;
    },
    setSelectedTab(selectedTab) {
      this.$emit('setSelectedTab', selectedTab);
    }
  }
};
</script>

<style scoped>
.container {
  background: #f5f5f5;
}

.tab-section {
  padding: 20px 20px 0px 20px;
  background: #f5f5f5;
}

.tab-item {
  padding-bottom: 10px;
  color: #3e3e3e;
}

.tab-count {
  padding-top: 18px;
  padding-bottom: 17px;
  border-right: 1px solid #d3d3d3;
  color: #4D4D4D;
}

.tab-search {
  position: relative;
  min-height: 55px;
  border-right: 1px solid #d3d3d3;
}

.search-input-field {
  padding-left: 50px;
  width: 100%;
  border: 0;
  height: 54px;
  outline: none;
}

.list-user-action-section {
  background: #ffffff;
  border: 1px solid #d3d3d3;
}

.search-icon {
  position: absolute;
  left: 16px;
  top: 15px;
}

.tabs > .active {
  border-bottom: 2px solid #01518a;
  color: #000001;
}

.sub-section {
  padding: 20px;
}
</style>
